<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
          :disabled="isEditPage"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_PAMSettings')">
      <el-checkbox
        class="PAMEnableCheckbox"
        v-model="model.params.pam_enabled"
        :disabled="isEditPage"
        :label="$t('Integrations_Field_Enabled')"
        true-label="1"
        false-label="0"
      />
      <rest-form-item
        v-if="isPamEnabled"
        :label="$t('Integrations_Field_Host')"
        prop="params.pam_host"
      >
        <el-input v-model="model.params.pam_host" :disabled="isEditPage" />
      </rest-form-item>

      <rest-form-item
        v-if="isPamEnabled"
        :label="$t('Integrations_Field_Username')"
        prop="params.pam_username"
      >
        <el-input v-model="model.params.pam_username" :disabled="isEditPage" />
      </rest-form-item>

      <rest-form-item
        v-if="isPamEnabled"
        :label="$t('Integrations_Field_Password')"
        prop="params.pam_password"
      >
        <el-input
          v-model="model.params.pam_password"
          type="password"
          :disabled="isEditPage"
        />
      </rest-form-item>

      <rest-form-item
        v-if="isPamEnabled"
        :label="$t('Integrations_Settings_Group')"
        prop="params.pam_group"
      >
        <el-input v-model="model.params.pam_group" :disabled="isEditPage" />
      </rest-form-item>

      <template v-if="isPamEnabled">
        <rest-form-item class="topic-toggle-fi" prop="params.cmd_topic_toggle">
          <toggle
            class="topic-toggle"
            v-model="model.params.cmd_topic_toggle"
            :active-text="$t('Integrations_Settings_UseCommandTopic')"
            :inactive-text="$t('Integrations_Settings_UseCommandTopic')"
            :disabled="isEditPage"
          />
        </rest-form-item>
        <rest-form-item ref="cmdTopic" prop="params.cmd_topic">
          <el-input
            v-if="model.params.cmd_topic_toggle"
            v-model="model.params.cmd_topic"
            :disabled="isEditPage"
          />
        </rest-form-item>
      </template>

      <template v-if="isPamEnabled">
        <rest-form-item class="topic-toggle-fi" prop="params.pdp_topic_toggle">
          <toggle
            class="topic-toggle"
            v-model="model.params.pdp_topic_toggle"
            :active-text="$t('Integrations_Settings_UsePDPTopic')"
            :inactive-text="$t('Integrations_Settings_UsePDPTopic')"
            :disabled="isEditPage"
          />
        </rest-form-item>
        <rest-form-item ref="pdpTopic" prop="params.pdp_topic">
          <el-input
            v-if="model.params.pdp_topic_toggle"
            v-model="model.params.pdp_topic"
            :disabled="isEditPage"
          />
        </rest-form-item>
      </template>
    </form-section>

    <form-section :title="$t('Integrations_Settings_EDrawSettings')">
      <el-checkbox
        class="PAMEnableCheckbox"
        v-model="model.params.edraw_enabled"
        :disabled="isEditPage"
        :label="$t('Integrations_Field_Enabled')"
        true-label="1"
        false-label="0"
      />

      <rest-form-item
        v-if="isEdrawEnabled"
        :label="$t('Integrations_Field_Host')"
        prop="params.events_host"
      >
        <el-input v-model="model.params.events_host" :disabled="isEditPage" />
      </rest-form-item>

      <rest-form-item
        v-if="isEdrawEnabled"
        :label="$t('Integrations_Field_Username')"
        prop="params.events_username"
      >
        <el-input
          v-model="model.params.events_username"
          :disabled="isEditPage"
        />
      </rest-form-item>

      <rest-form-item
        v-if="isEdrawEnabled"
        :label="$t('Integrations_Field_Password')"
        prop="params.events_password"
      >
        <el-input
          v-model="model.params.events_password"
          type="password"
          :disabled="isEditPage"
        />
      </rest-form-item>

      <rest-form-item
        v-if="isEdrawEnabled"
        :label="$t('Integrations_Settings_Group')"
        prop="params.events_group"
      >
        <el-input v-model="model.params.events_group" :disabled="isEditPage" />
      </rest-form-item>

      <template v-if="isEdrawEnabled">
        <rest-form-item
          class="topic-toggle-fi"
          prop="params.edraw_topic_toggle"
        >
          <toggle
            class="topic-toggle"
            v-model="model.params.edraw_topic_toggle"
            :active-text="$t('Integrations_Settings_UseEDrawTopic')"
            :inactive-text="$t('Integrations_Settings_UseEDrawTopic')"
            :disabled="isEditPage"
          />
        </rest-form-item>
        <rest-form-item ref="edrawTopic" prop="params.edraw_topic">
          <el-input
            v-if="model.params.edraw_topic_toggle"
            v-model="model.params.edraw_topic"
            :disabled="isEditPage"
          />
        </rest-form-item>
      </template>

      <template v-if="isEdrawEnabled">
        <rest-form-item class="topic-toggle-fi" prop="params.sc_topic_toggle">
          <toggle
            class="topic-toggle"
            v-model="model.params.sc_topic_toggle"
            :active-text="$t('Integrations_Settings_UseSCTopic')"
            :inactive-text="$t('Integrations_Settings_UseSCTopic')"
            :disabled="isEditPage"
          />
        </rest-form-item>
        <rest-form-item ref="scTopic" prop="params.second_chance_topic">
          <el-input
            v-if="model.params.sc_topic_toggle"
            v-model="model.params.second_chance_topic"
            :disabled="isEditPage"
          />
        </rest-form-item>
      </template>
    </form-section>

    <form-section
      :title="$t('Integrations_Igt_Identifier_Mapping_Title')"
      :description="$t('Integrations_Igt_Identifier_Mapping_Description')"
    >
      <el-select v-model="model.params.id_mapping" :disabled="isEditPage">
        <el-option
          v-for="option in identifierOptions"
          :key="option.value"
          :value="option.value"
          :label="option.label"
        />
      </el-select>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import Toggle from '@/common/components/form/Toggle'

export default {
  name: 'IgtSettings',
  components: {
    RestFormItem,
    FormSection,
    Toggle
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  mounted() {
    if (!this.model.params.hasOwnProperty('id_mapping')) {
      this.$set(this.model.params, 'id_mapping', 'user_id')
    }

    if (!this.model.params.hasOwnProperty('approved')) {
      this.$set(this.model.params, 'approved', 0)
    }
    this.setDefaultGroupName()
    this.initTopicToggles()
    this.initSectionToggles()
  },

  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          events_username: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          events_password: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          events_group: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          events_host: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          pam_host: [
            {
              required: false,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          pam_username: [
            {
              required: false,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          pam_password: [
            {
              required: false,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          pam_group: [
            {
              required: false,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          edraw_topic: [
            {
              required: false,
              message: this.$t('Integrations_Igt_Settings_RequiredEDrawTopic')
            }
          ],
          second_chance_topic: [
            {
              required: false,
              message: this.$t('Integrations_Igt_Settings_RequiredSCTopic')
            }
          ],
          cmd_topic: [
            {
              required: false,
              message: this.$t('Integrations_Igt_Settings_RequiredCommandTopic')
            }
          ],
          pdp_topic: [
            {
              required: false,
              message: this.$t('Integrations_Igt_Settings_RequiredPDPTopic')
            }
          ],
          cmd_topic_toggle: [
            {
              validator: (rule, value, callback) => {
                if (this.isCMDTopicRequired && !value) {
                  callback(
                    new Error(
                      this.$t('Integrations_Igt_Settings_RequiredCommandTopic')
                    )
                  )
                } else {
                  callback()
                }
              },
              trigger: 'change'
            }
          ],
          pdp_topic_toggle: [
            {
              validator: (rule, value, callback) => {
                if (this.isPDPTopicRequired && !value) {
                  callback(
                    new Error(
                      this.$t('Integrations_Igt_Settings_RequiredPDPTopic')
                    )
                  )
                } else {
                  callback()
                }
              },
              trigger: 'change'
            }
          ],
          edraw_topic_toggle: [
            {
              validator: (rule, value, callback) => {
                if (this.isEdrawTopicRequired && !value) {
                  callback(
                    new Error(
                      this.$t('Integrations_Igt_Settings_RequiredEDrawTopic')
                    )
                  )
                } else {
                  callback()
                }
              },
              trigger: 'change'
            }
          ],
          sc_topic_toggle: [
            {
              validator: (rule, value, callback) => {
                if (this.isSecondChanceTopicRequired && !value) {
                  callback(
                    new Error(
                      this.$t('Integrations_Igt_Settings_RequiredSCTopic')
                    )
                  )
                } else {
                  callback()
                }
              },
              trigger: 'change'
            }
          ]
        }
      },
      identifierOptions: [
        {
          value: 'user_id',
          label: this.$t('Integrations_Igt_Identifier_Mapping_User_Id')
        }
      ],
      groupOptions: ['xtremepush-group', 'dev-xtremepush-group'],
      revalidate: false
    }
  },

  methods: {
    setDefaultGroupName() {
      const defaultGroup =
        this.$store.state.app.server.group === 'prod'
          ? 'xtremepush-group'
          : 'dev-xtremepush-group'

      if (!this.model.params.events_group) {
        this.$set(this.model.params, 'events_group', defaultGroup)
      }

      if (!this.model.params.pam_group) {
        this.$set(this.model.params, 'pam_group', defaultGroup)
      }
    },
    initSectionToggles() {
      if (this.isEditPage) {
        if (!this.model.params.hasOwnProperty('edraw_enabled')) {
          this.$set(
            this.model.params,
            'edraw_enabled',
            this.model.params.events_host ? '1' : '0'
          )
        }
        if (!this.model.params.hasOwnProperty('pam_enabled')) {
          this.$set(
            this.model.params,
            'pam_enabled',
            this.model.params.pam_host ? '1' : '0'
          )
        }
      } else {
        this.$set(this.model.params, 'pam_enabled', '0')
        this.$set(this.model.params, 'edraw_enabled', '0')
      }
    },
    initTopicToggles() {
      this.$set(
        this.model.params,
        'pdp_topic_toggle',
        this.model.params.pdp_topic ? 1 : 0
      )
      this.$set(
        this.model.params,
        'cmd_topic_toggle',
        this.model.params.cmd_topic ? 1 : 0
      )
      this.$set(
        this.model.params,
        'edraw_topic_toggle',
        this.model.params.edraw_topic ? 1 : 0
      )
      this.$set(
        this.model.params,
        'sc_topic_toggle',
        this.model.params.second_chance_topic ? 1 : 0
      )
    }
  },

  computed: {
    isEditPage() {
      return !!this.$route.query.id
    },
    isPamEnabled() {
      return this.model.params.pam_enabled === '1'
    },
    isEdrawEnabled() {
      return this.model.params.edraw_enabled === '1'
    },
    isSecondChanceTopicRequired() {
      return this.isEdrawEnabled && !this.model.params.edraw_topic_toggle
    },
    isEdrawTopicRequired() {
      return this.isEdrawEnabled && !this.model.params.sc_topic_toggle
    },
    isPDPTopicRequired() {
      return this.isPamEnabled && !this.model.params.cmd_topic_toggle
    },
    isCMDTopicRequired() {
      return this.isPamEnabled && !this.model.params.pdp_topic_toggle
    }
  },
  watch: {
    model: {
      handler(val) {
        this.rules.params.pam_host[0].required = this.isPamEnabled
        this.rules.params.pam_username[0].required = this.isPamEnabled
        this.rules.params.pam_password[0].required = this.isPamEnabled
        this.rules.params.pam_group[0].required = this.isPamEnabled
        this.rules.params.cmd_topic[0].required = !!this.model.params
          .cmd_topic_toggle
        this.rules.params.pdp_topic[0].required = !!this.model.params
          .pdp_topic_toggle

        this.rules.params.events_host[0].required = this.isEdrawEnabled
        this.rules.params.events_username[0].required = this.isEdrawEnabled
        this.rules.params.events_password[0].required = this.isEdrawEnabled
        this.rules.params.events_group[0].required = this.isEdrawEnabled
        this.rules.params.second_chance_topic[0].required = !!this.model.params
          .sc_topic_toggle
        this.rules.params.edraw_topic[0].required = !!this.model.params
          .edraw_topic_toggle
      },
      deep: true
    },
    'model.params.sc_topic_toggle': {
      handler(val) {
        this.$parent.validateField('params.edraw_topic_toggle')
        this.$parent.validateField('params.edraw_topic')
      }
    },
    'model.params.edraw_topic_toggle': {
      handler(val) {
        this.$parent.validateField('params.sc_topic_toggle')
        this.$parent.validateField('params.second_chance_topic')
      }
    },
    'model.params.pdp_topic_toggle': {
      handler(val) {
        this.$parent.validateField('params.cmd_topic_toggle')
        this.$parent.validateField('params.cmd_topic')
      }
    },
    'model.params.cmd_topic_toggle': {
      handler(val) {
        this.$parent.validateField('params.pdp_topic_toggle')
        this.$parent.validateField('params.pdp_topic')
      }
    }
  }
}
</script>

<style scoped>
.PAMEnableCheckbox {
  margin-bottom: 22px;
}
.topic-toggle {
  margin-bottom: 10px;
}
>>> .el-form-item.topic-toggle-fi {
  margin-bottom: 0;
}
>>> .el-form-item.topic-toggle-fi .el-form-item__error {
  padding-top: unset;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/igt/IgtSettings.vue